import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { dateTime } from "@/lib/format";

export function SubscribersPanel() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/newsletter").then((r) => setData(r.data)).catch(() => {}); }, []);
  if (!data) return null;
  return (
    <article className="dpa-panel dpa-history" data-testid="subscribers-panel">
      <h2>Newsletter subscribers <span className="text-blue-300" data-testid="subscribers-count">· {data.count}</span></h2>
      <div className="dpa-table-scroll">
        <table>
          <thead><tr><th>Email</th><th>Subscribed</th></tr></thead>
          <tbody>
            {data.subscribers.map((s) => (
              <tr key={s.email} data-testid={`subscriber-${s.email}`}><td>{s.email}</td><td className="whitespace-nowrap">{dateTime(s.created_at)}</td></tr>
            ))}
          </tbody>
        </table>
      </div>
      {!data.count && <p className="dpa-empty">No subscribers yet. Emails from the footer “Stay updated” form appear here.</p>}
    </article>
  );
}
